import React from "react";
import './UserIcon.scss';

const UserIcon = () => {
  return (
    <span className="badge badge-primary UserIcon__container">
      <i className="fas fa-user-plus" />
    </span>
  );
};

export default UserIcon;



// WEBPACK FOOTER //
// ./src/components/UserIcon/UserIcon.jsx